//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CloudNuxtWebWikiselect',
  props: {
    datalist: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      select: { value: 1, label: '' },
      optionList: [],
      isShowSelect: false
    }
  },
  // watch: {
  //   datalist: {
  //     handler (n) {
  //       if (n) this.optionList = JSON.parse(JSON.stringify(this.datalist))
  //     },
  //     deep: true
  //   }
  // },
  created () {
    this.optionList = JSON.parse(JSON.stringify(this.datalist))
    Object.assign(this.select, this.optionList[0])
  },
  mounted () {
    document.addEventListener('mouseup', this.closeEmo)
  },
  destroyed () {
    document.removeEventListener('mouseup', this.closeEmo)
  },
  methods: {
    checkOption (item) {
      Object.assign(this.select, item)
      this.$emit('changeOption', item)
      this.isShowSelect = false
    },
    // 关闭下拉框
    closeEmo (e) {
      if (!this.$refs?.menuSelect?.contains(e.target)) this.isShowSelect = false
    }
  }
}
